export const frag = /*glsl*/ `
precision lowp float;

uniform float uVisiblity;
uniform float uMapSize;
uniform float uColorInfluence;

uniform vec3 uColor;

uniform sampler2D tMap;
uniform sampler2D tEmissiveMap;
uniform sampler2D tNoise;
uniform sampler2D tShadowMap;

uniform vec3 uSunPosition;
uniform float uSunIntensity;
uniform float uAmbientIntensity;
uniform float uDiffuseSaturation;
uniform float uDiffuseIntensity;
uniform float uDiffuseContrast;
uniform float uShadowIntensity;
uniform float uEmissiveSaturation;
uniform float uEmissiveIntensity;
uniform float uEmissiveAddition;
uniform float uPostEmissiveSaturation;
uniform float uPostEmissiveIntensity;
uniform float uPostEmissiveAddition;
uniform float uAoIntensity;
uniform float uVisiblity2;
uniform float uUseShadowMap;

varying float vOnlyEmissive;
varying vec3 vNormal;
varying vec3 vPosition;
varying vec2 vUv;
varying vec2 vUv2;
varying vec2 vCustomUv;

#define GROUND vec3(0., 0., 1.)

vec3 czm_saturation(vec3 rgb, float adjustment) {
    return mix(vec3(dot(rgb, vec3(0.2125, 0.7154, 0.0721))), rgb, adjustment);
}

float pow2(float x) {return x*x;}

void main(){
	vec3 emissive = texture2D(tEmissiveMap, vCustomUv).rgb;

	vec3 diffuse = czm_saturation(texture2D(tMap, vUv).rgb, uDiffuseSaturation) * uDiffuseIntensity;

	float visibility = 1. - uVisiblity * uVisiblity2;
	float noise = texture2D(tNoise, ((vUv * uMapSize) / 256.)).r;
	float progress = smoothstep(visibility - .3, visibility, .2 - vPosition.y * .2 + noise * .2);
	if (progress < .1) discard;

	float light = smoothstep(0., 1., dot(vNormal, normalize(uSunPosition))) * uSunIntensity + uAmbientIntensity;
	float shadow = uShadowIntensity + (1. - uShadowIntensity);

	vec3 color = diffuse * light * shadow * (uColor * uColorInfluence + (1. - uColorInfluence));

	color = color * ((texture2D(tShadowMap, vUv2).r * 2.) * uAoIntensity + (1.2 - uAoIntensity));

	vec3 glow = uColor * sqrt(smoothstep(1., -1.5, vPosition.y)) * .2;
	color += czm_saturation(emissive, uEmissiveSaturation) * uEmissiveAddition;

	color += mix(glow * uColorInfluence, emissive * uEmissiveIntensity, clamp(length(emissive), 0., 1.));
	color = mix(color, uColor, smoothstep(.5, 0., progress));

	vec3 postEmissive = czm_saturation(emissive, uPostEmissiveSaturation) * uPostEmissiveIntensity + uPostEmissiveAddition * smoothstep(.0, .01, length(emissive));
	gl_FragColor = vec4(mix(color, postEmissive, vOnlyEmissive), 1.);
	gl_FragColor.rgb = gl_FragColor.rgb * (1. + uDiffuseContrast) - uDiffuseContrast;
	
	gl_FragColor.rgb *= smoothstep(0., .2, texture2D(tShadowMap, vUv2).rgb) * .4 * uUseShadowMap + .6 + (1. - uUseShadowMap) * .4;
}`;
